import React, {useRef} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import './Search.css';
import objeler from '../objeler';

const textStyle = {
    display: "inline-block",
    width: "96%",
    height: "20px",
    zIndex: "0",
    fontSize: "14px",
    fontFamily: 'Raleway, Arial',
    overflow: 'hidden',
    marginLeft: '4px',
    marginTop: '1px'
};
const SearchBar = ({posts, setSearchResults}) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        margin: {
            margin: theme.spacing(1),
        },
        withoutLabel: {
            marginTop: theme.spacing(3),
        },
        textField: {
            width: '25ch',
            height: '5px',
            padding: '0px'
        },
    }));
    const classes = useStyles();
    const styles = {
        input1: {
            height: '1px'
        },
        input2: {
            height: 200,
            fontSize: "3em"
        }
    };
    const searchBarText = useRef([])
    const handleSubmit = (e) => e.preventDefault()
    const filter = (text, items) => {
        console.log('items', items)
        return items.filter(p => p.Name.toLowerCase().includes(text.toLowerCase()) || p.Date.toLowerCase().includes(text.toLowerCase()))
    }
    const handleSearchChange = (e) => {
        if (!e.target.value) return setSearchResults(posts)
        const resultsArray = filter(e.target.value, posts)
        setSearchResults(resultsArray)
    }
    const refresh = () => {
        const resultsArray = filter(searchBarText.current.value, posts)
        console.log('resultsArray', resultsArray)
        setSearchResults(resultsArray)
    }
    objeler["SearchBarRefresh"] = refresh;
    return (
        <header>
            <form className="search" onSubmit={handleSubmit}>
                <input
                    ref={searchBarText}
                    className="search__input"
                    type="search"
                    id="search"
                    rel="search"
                    name="search"
                    onChange={handleSearchChange}
                    style={textStyle}
                    placeholder="Search Document"
                    autocomplete="off"
                />&nbsp;
            </form>
        </header>
    )
}
export default SearchBar